export default __webpack_public_path__ + "static/office-map-fb5627ac17a555d82047e51a37ffb2c7.svg";